module.exports = __webpack_public_path__ + "static/media/meeting_right_icon.d0ac3eff.svg";